(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("s360", [], factory);
	else if(typeof exports === 'object')
		exports["s360"] = factory();
	else
		root["s360"] = factory();
})(self, () => {
return 